import React from 'react';
import IconButton from '../Button/IconButton';
import Icon from '../Icon/Icon';
import './MobileMenuButton.css';

interface MobileMenuButtonProps {
  onClick: () => void;
  className?: string;
}

const MobileMenuButton: React.FC<MobileMenuButtonProps> = ({ onClick, className = '' }) => {
  return (
    <IconButton
      icon={<Icon name="menu" size="large" />}
      onClick={onClick}
      ariaLabel="Open menu"
      className={`mobile-menu-button ${className}`}
    />
  );
};

export default MobileMenuButton; 